<agpr-dialog-container
    [id]="id"
    heading="Monitor.precisionClip.complete.header"
    headingIcon="fa-kit-duotone fa-agpr-ai-generic"
    [fitContent]="true"
    [closeOnClickOutside]="closeOnClickOutside"
    (close)="cancel()"
>
    <div
        class="agpr-precisionConfirm-content"
        [ngStyle]="{ width: width ? width + 'px' : '' }"
    >
        <agpr-scroll-panel>
           <div class="agpr-precisionConfirm-column">
                <p class="agpr-precisionConfirm-intro">
                    {{ 'Monitor.precisionClip.complete.body.intro' | localize }}
                </p>

                <div class="agpr-precisionConfirm-box">
                    <p class="auto-clip-notice__stat">
                        <span class="agpr-precisionConfirm-label">
                            {{ 'Monitor.precisionClip.complete.body.success' | localize }}
                        </span>
                        {{ successCount }}
                    </p>
                    <p class="auto-clip-notice__stat">
                        <span class="agpr-precisionConfirm-label">
                            {{ 'Monitor.precisionClip.complete.body.failed' | localize }}
                        </span>
                        {{ failedCount }}
                    </p>
                </div>
            </div>
        </agpr-scroll-panel>
    </div>


    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_confirmDialog_ok'"
            label="Monitor.results.briefingNotFoundDialog.acknowledge"
            [style]="buttonTypes.primary"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
